import { type FC } from "react";

import { ArrowForward } from "@livechat/design-system-icons";
import { Button, Icon, Text } from "@livechat/design-system-react-components";

import logoText from "assets/svg/logo-text.svg";
import { config } from "config/config";
import { redirect } from "helpers/routing";

import * as styles from "./styles";

export const BackToTextApp: FC = (): JSX.Element => {
  function openTextApp(): void {
    redirect(`${config.textAppHost}/inbox/tickets`);
  }

  return (
    <div css={styles.container}>
      <div css={styles.banner}>
        <img css={styles.logo} src={logoText} alt="Text App logo" />
        <Text size="lg">Your work happens in Text App now. Manage chats, tickets, and automations in one place.</Text>
        <div>
          <Button kind="high-contrast" size="compact" onClick={openTextApp}>
            <div css={styles.button}>
              <Text bold>Continue in Text App</Text>
              <Icon source={ArrowForward} />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};
